import { render, staticRenderFns } from "./brand_logo.vue.js?vue&type=template&id=5e6c01b2!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./brand_logo.vue?vue&type=template&id=5e6c01b2"
import script from "./brand_logo.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./brand_logo.vue?vue&type=script&lang=js"
export * from "./brand_logo.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./brand_logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6c01b2')) {
      api.createRecord('5e6c01b2', component.options)
    } else {
      api.reload('5e6c01b2', component.options)
    }
    module.hot.accept("./brand_logo.vue.js?vue&type=template&id=5e6c01b2!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./brand_logo.vue?vue&type=template&id=5e6c01b2", function () {
      api.rerender('5e6c01b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/brand_logo.vue"
export default component.exports